import React from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/SEO'
import get from 'lodash/get'
import Img from 'gatsby-image'
import Layout from '../components/Layout'

import heroStyles from '../css/hero.module.css'
import blogStyles from './blog-post.module.css'

class BlogPostTemplate extends React.Component {
  render() {
    const post = get(this.props, 'data.contentfulBlogPost')

    return (
      <Layout location={this.props.location}>
        <div className="">
          <SEO title={`${post.title}`} />
          <div className={heroStyles.hero}>
            <Img
              className={blogStyles.blogImage}
              alt={post.title}
              fluid={post.heroImage.fluid}
            />
          </div>
          <div className="wrapper max-w-5xl">
            <h1 className="text-3xl sm:text-4xl font-extrabold">{post.title}</h1>
            <p
              className="text-sm text-gray-700"
            >
              {post.publishDate}
            </p>
            <div
              className="mt-4 blog-body"
              dangerouslySetInnerHTML={{
                __html: post.body.childMarkdownRemark.html,
              }}
            />
          </div>
        </div>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      publishDate(formatString: "MMMM Do, YYYY")
      heroImage {
        fluid(maxWidth: 1180, background: "rgb:000000") {
          ...GatsbyContentfulFluid
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`
